var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"spinner-grow text-danger",attrs:{"role":"status"}}),(_vm.text)?_c('p',{staticClass:"mb-0 mt-2 text-light"},[_vm._v(_vm._s(_vm.text))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }